import { render, staticRenderFns } from "./unsubscribe-page.vue?vue&type=template&id=3d977ba7"
import script from "./unsubscribe-page.vue?vue&type=script&lang=js"
export * from "./unsubscribe-page.vue?vue&type=script&lang=js"
import style0 from "./unsubscribe-page.vue?vue&type=style&index=0&id=3d977ba7&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports